import { Config } from "@/shared/config";

export const getFormattedBookingDay = (): string => {
  const days = {
    'monday': 'lunedì',
    'tuesday': 'martedì',
    'wednesday': 'mercoledì',
    'thursday': 'giovedì',
    'friday': 'venerdì',
    'saturday': 'sabato',
    'sunday': 'domenica'
  };
  return days[Config.BOOKING_ALLOWED_FROM.day as keyof typeof days] || Config.BOOKING_ALLOWED_FROM.day;
};

export const getFormattedBookingTime = (): string => {
  return `${Config.BOOKING_ALLOWED_FROM.hour.toString().padStart(2, '0')}:${Config.BOOKING_ALLOWED_FROM.minute.toString().padStart(2, '0')}`;
};

export const replaceBookingPlaceholders = (text: string): string => {
  if (!text) return text;
  return text
    .replace(/\{\{bookingDay\}\}/g, getFormattedBookingDay())
    .replace(/\{\{bookingTime\}\}/g, getFormattedBookingTime());
};